import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentoDetalleService {
  constructor(private gqlclient: GraphQLClient) { }

  ValidarDetalleNotaCredito(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              validarDetalleNotaCredito(entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  nro_linea
                  producto_codigo
                  formato_codigo
                  descripcion_producto
                  cantidad
                  precio_neto
                  precio_unitario
                  monto_total_neto
                  monto_total
                  es_producto_libre
                  es_facturable
                  gasto_codigo
                  equivalencia_producto_id
                  sku
                  motivo_devolucion_especifico_codigo
                  es_correcion_monto
                  unidad_negocio_codigo
                  atributos {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    tipo_atributo_codigo
                    nro_linea
                    impuesto_codigo
                    porcentaje
                    monto
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.validarDetalleNotaCredito;
        callback({ mensajes, respuesta });
      }
    );
  }

  ValidarDetalleNotaDebito(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              validarDetalleNotaDebito(entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  rut_emisor
                  folio
                  tipo_dte_codigo
                  nro_linea
                  producto_codigo
                  formato_codigo
                  descripcion_producto
                  cantidad
                  precio_neto
                  precio_unitario
                  monto_total_neto
                  monto_total
                  es_producto_libre
                  es_facturable
                  gasto_codigo
                  equivalencia_producto_id
                  sku
                  motivo_devolucion_especifico_codigo
                  es_correcion_monto
                  unidad_negocio_codigo
                  atributos {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    tipo_atributo_codigo
                    nro_linea
                    impuesto_codigo
                    porcentaje
                    monto
                    es_porcentaje
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.validarDetalleNotaDebito;
        callback({ mensajes, respuesta });
      }
    );
  }

  AgregarDetalleCorrecionMonto(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              agregarDetalleCorrecionMonto(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    motivo_devolucion_especifico_codigo
                    es_correcion_monto
                    unidad_negocio_codigo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.agregarDetalleCorrecionMonto;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerSegunFiltro(
    inputParams: {
      rut_emisor: number;
      folio: number;
      tipo_dte_codigo: number;
      paginaActual: number;
      cantidadRegistrosPorPagina: number;
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($rut_emisor: Decimal, $folio: Decimal, $tipo_dte_codigo: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            documento_detalle {
              obtenerSegunFiltro(
                filtro: { exacto: { rut_emisor: $rut_emisor, folio: $folio, tipo_dte_codigo: $tipo_dte_codigo } }
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_emisor
                    folio
                    formato_nombre
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    formato_codigo
                    descripcion_producto
                    cantidad
                    precio_neto
                    precio_unitario
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    sku
                    motivo_devolucion_especifico_codigo
                    es_correcion_monto
                    aplicacion_descuento
                    aplicacion_recargo
                    aplicacion_imp_adic
                    unidad_negocio_codigo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.obtenerSegunFiltro;
        callback({ mensajes, respuesta });
      }
    );
  }

  agregarDetalleProductoLibreGuiaDespacho(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              agregarDetalleProductoLibreGuiaDespacho(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    descuento_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_pesos
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    es_afecto_reglas_comerciales
                    es_exento
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    promocion_codigo
                    descuento_codigo
                    unidad_negocio_codigo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.agregarDetalleProductoLibreGuiaDespacho;
        callback({ mensajes, respuesta });
      }
    );
  }

  eliminarDetalleProductoGuiaDespacho(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType, $entidad_detalleDTO: documento_detalleDTOInputType) {
            documento_detalle {
              eliminarDetalleProductoGuiaDespacho(entidadDTO: $entidadDTO, entidad_detalleDTO: $entidad_detalleDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    cantidad_original
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    descuento_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_pesos
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    es_afecto_reglas_comerciales
                    es_exento
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    promocion_codigo
                    descuento_codigo
                    unidad_negocio_codigo
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.eliminarDetalleProductoGuiaDespacho;
        callback({ mensajes, respuesta });
      }
    );
  }

  actualizarDetalleNota(
    inputParams: {
      entidadDTO: {
        cabecera: {
          rut_emisor: number;
          sucursal_codigo: number;
          cliente_proveedor_rut: number;
          direccion_codigo: number;
          lista_precio_codigo?: number;
          es_correcion_monto: boolean;
          es_nc: boolean;
        };
        descuentosGlobales: any[];
        detalleDocumento: any[];
      };
    },
    callback: Function
  ) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidadDTO: documentoDTOInputType) {
            documento_detalle {
              actualizarDetalleNota(entidadDTO: $entidadDTO) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    formato_original
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    cantidad_original
                    precio_neto
                    precio_unitario
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    sku
                    motivo_devolucion_especifico_codigo
                    es_correcion_monto
                    aplicacion_descuento
                    aplicacion_recargo
                    aplicacion_imp_adic
                    seleccion
                    unidad_negocio_codigo
                    no_aplica_descuento
                    precio_unitario_original
                    listaProductoFormato {
                      producto_codigo
                      formato_codigo
                      formato_nombre
                      formato_codigo_top
                      formato_secundario
                      label
                      value
                      cantidad
                    }
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.actualizarDetalleNota;
        callback({ mensajes, respuesta });
      }
    );
  }

  actualizarDetalle(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: documentoDTOInputType, $detalle: documento_detalleDTOInputType) {
            documento_detalle {
              actualizarDetalle(entidad: $entidad, detalle: $detalle) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  registros {
                    rut_emisor
                    folio
                    tipo_dte_codigo
                    nro_linea
                    producto_codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion_producto
                    cantidad
                    precio_unitario
                    precio_neto
                    monto_total_neto
                    monto_total
                    es_producto_libre
                    es_facturable
                    gasto_codigo
                    equivalencia_producto_id
                    descuento_linea_pesos
                    descuento_linea_porcentaje
                    recargo_linea_pesos
                    recargo_linea_porcentaje
                    aplicacion_descuento
                    aplicacion_recargo
                    es_afecto_reglas_comerciales
                    es_exento
                    es_combo
                    es_descuento
                    es_promocion
                    es_promocion_condicional
                    promocion_codigo
                    descuento_codigo
                    tipo_producto_codigo
                    unidad_negocio_codigo
                    no_aplica_descuento
                    atributos {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      tipo_atributo_codigo
                      nro_linea
                      impuesto_codigo
                      porcentaje
                      monto
                      es_porcentaje
                    }
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.documento_detalle.actualizarDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }
}
